import ResponsiveTable from "./ResponsiveTable";
export default ResponsiveTable;
